export default {
  'nav.brand': 'AllChinaBuy Spreadsheet',
  'nav.categories': 'Categories',
  'nav.guides': 'Guides',
  'nav.faq': 'FAQ',
  'nav.explore': 'Explore Spreadsheet',
  'nav.home': 'Home',
  'nav.shoppingGuide': 'Shopping Guide',
  'nav.sheetCta': 'AllChinaBuy Sheet',

  'hero.badge': 'UPDATED WEEKLY · 2026 EDITION',
  'hero.title': 'The Most Complete AllChinaBuy Spreadsheet Directory',
  'hero.titlePre': 'The Most Complete',
  'hero.titleHighlight': 'AllChinaBuy Spreadsheet',
  'hero.titleSuffix': 'Directory',
  'hero.subtitle': 'Discover thousands of curated product finds across shoes, clothing, bags, accessories and more. Updated weekly with quality-checked listings and organized categories for smart shoppers.',
  'hero.cta1': 'AllChinaBuy Sheet',
  'hero.cta2': 'Buy It Now',
  'hero.trust1': 'Updated Weekly',
  'hero.trust2': 'Quality Checked',
  'hero.trust3': 'Verified',

  'trust.independent': 'Independent Resource',
  'trust.research': 'Research-Focused',
  'trust.updated': 'Regularly Updated',

  'selector.title': 'Browse by Category',
  'selector.placeholder': 'Select a category…',
  'selector.all': 'All Categories',

  'categories.title': 'Popular Categories',
  'categories.badge': 'CURATED',
  'categories.intro': 'Navigate through our carefully organized collection of AllChinaBuy spreadsheets. Each category links directly to verified product listings on our main store.',
  'categories.subtitle': 'Pick a category to explore matching products on the main website.',
  'categories.browse': 'Browse this category',

  'features.title': 'Why Use a Spreadsheet for Product Research?',
  'feature1.title': 'Everything in One Place',
  'feature1.desc': 'Browse shoes, clothing, bags and more from a single organized hub instead of searching across many pages.',
  'feature2.title': 'Clear Categories',
  'feature2.desc': 'Jump straight to the category you care about with a quick dropdown or one-click buttons.',
  'feature3.title': 'Independent & Honest',
  'feature3.desc': 'An independent resource focused on discovery, with no fake reviews, prices or coupons.',

  'guide.title': 'What Is the AllChinaBuy Spreadsheet?',
  'guide.p1': 'An AllChinaBuy spreadsheet is an organized way to browse product finds. It groups popular items into clear categories — shoes, hoodies, t-shirts, jackets, pants, accessories and more — so you can discover products quickly and plan smarter purchases.',
  'guide.p2': 'Instead of searching page by page, you can use the categories above to jump straight to the section you need. Each link takes you to the matching category on the main website.',
  'guide.p3': 'This is an independent resource built around product discovery. We focus on helpful, original guidance — no fake reviews, prices or coupons — so you always know what you are looking at.',
  'guide.readMore': 'Read the Full Guide',
  'guide.readMoreSub': 'Learn how to use the spreadsheet for product research, plus practical tips and FAQs.',

  'companion.badge': 'About AllChinaBuy Sheet',
  'companion.title': 'Your Ultimate Shopping Companion',
  'companion.p1': 'The <strong>AllChinaBuy spreadsheet</strong> has become an essential tool for thousands of savvy shoppers worldwide. Whether you are hunting for the latest sneaker releases, premium streetwear pieces, or hidden luxury gems, having a well-organized <strong>product directory</strong> can save you hours of browsing and help you discover products you would never find on your own.',
  'companion.p2': 'Our <strong>AllChinaBuy spreadsheet 2026</strong> directory brings together the most comprehensive collection of verified finds — from Nike and Jordan sneakers to Essentials hoodies, Chrome Hearts accessories, and everything in between. Each spreadsheet is regularly updated to ensure you always have access to the freshest drops and best-value items.',
  'companion.p3': 'What sets our directory apart is the level of curation. We do not just list every spreadsheet we come across. Every entry in our <strong>AllChinaBuy spreadsheet</strong> collection is manually reviewed for quality, accuracy, and relevance. This means you spend less time digging through dead links and more time finding exactly what you want.',
  'companion.cta1': 'Visit Main Store',
  'companion.cta2': 'Read Full Guide',

  'why.badge': 'WHY CHOOSE US',
  'why.title': 'Trusted by Thousands of Shoppers',
  'why.subtitle': 'Our AllChinaBuy spreadsheet directory is built on reliability, freshness, and real user feedback — here is what makes it the go-to resource for smart shoppers in 2026.',
  'why.f1.title': 'Updated Weekly',
  'why.f1.desc': 'Our directory is refreshed every week with the latest finds, ensuring you never miss a new drop or trending item.',
  'why.f2.title': 'Quality Verified',
  'why.f2.desc': 'Every spreadsheet undergoes manual review before being listed. We check for dead links, outdated pricing, and inaccurate product descriptions.',
  'why.f3.title': 'Organized Categories',
  'why.f3.desc': 'Browse through 14 carefully organized categories — from sneakers and hoodies to accessories and fragrances — to find exactly what you need in seconds.',
  'why.f4.title': 'Fast Navigation',
  'why.f4.desc': 'Direct links to verified product listings on our main store eliminate guesswork and get you from browsing to buying faster than ever.',
  'why.f5.title': 'Comparison Guides',
  'why.f5.desc': 'Side-by-side comparisons help you evaluate different spreadsheet options, pricing tiers, and agent recommendations before committing.',
  'why.f6.title': 'Latest Finds',
  'why.f6.desc': 'Stay ahead of trends with early access to newly discovered gems, limited releases, and under-the-radar bargains across all categories.',

  'faq.title': 'Frequently Asked Questions',
  'faq.subtitle': 'Everything you need to know about AllChinaBuy spreadsheets, how they work, and how to get the most out of our directory.',
  'faq.q1': 'Is this an official AllChinaBuy website?',
  'faq.a1': 'No, this is an independent informational resource and is not operated by or affiliated with AllChinaBuy.',
  'faq.q2': 'Where can I buy the products?',
  'faq.a2': 'All category links take you to the main website, where you can browse full listings and make purchases.',
  'faq.q3': 'Is the spreadsheet free to use?',
  'faq.a3': 'Yes, browsing categories and guides here is completely free.',
  'faq.q4': 'How do I find a specific item?',
  'faq.a4': 'Choose the closest category from the dropdown or buttons, then browse the linked listings.',
  'faq.q5': 'How often are the spreadsheets updated?',
  'faq.a5': 'We aim to keep categories and guides current. Check back regularly for the latest finds and tips.',
  'faq.q6': 'Can I submit my own spreadsheet to be listed?',
  'faq.a6': 'Currently we do not accept user submissions. All listings are manually curated by our editorial team to maintain quality standards.',

  'cta.title': 'Ready to Explore the AllChinaBuy Spreadsheet?',
  'cta.subtitle': 'Browse categories and product finds, or head straight to the main website.',
  'cta.button1': 'AllChinaBuy Spreadsheet',
  'cta.button2': 'Buy It Now',

  'finalcta.title': 'Ready to Find Your Next Great Deal?',
  'finalcta.subtitle': 'Join thousands of smart shoppers already using our AllChinaBuy spreadsheet directory. Updated weekly with the latest verified finds across 14 categories.',
  'finalcta.button1': 'Browse Spreadsheets',
  'finalcta.button2': 'Read the Guide',

  'guides.badge': 'Buying Guides',
  'guides.title': 'AllChinaBuy Buying Guides',
  'guides.subtitle': 'In-depth, original guides to help you research products, order with confidence and ship smarter.',

  'footer.description': 'An independent resource hub for AllChinaBuy product finds, categories and buying guides.',
  'footer.tagline': 'Bookmark our site and check back weekly for the latest AllChinaBuy spreadsheet updates, new category additions, and fresh finds across all 14 categories.',
  'footer.readGuide': 'Read Full Guide',
  'footer.popularCategories': 'Popular Categories',
  'footer.quickLinks': 'Quick Links',
  'footer.mainStore': 'Main Store — AllChinaBuy Sheet',
  'footer.buyNow': 'Buy It Now',
  'footer.completeGuide': 'Complete Guide 2026',
  'footer.allCategories': 'All Categories',
  'footer.faq': 'FAQ',
  'footer.home': 'Home',
  'footer.mainStoreShort': 'Main Store',
  'footer.copyright': 'All rights reserved. Not affiliated with AllChinaBuy.',
  'footer.categoriesLink': 'Categories',
  'footer.guideLink': 'Buying Guide',
  'footer.faqLink': 'FAQ',
  'footer.disclaimer': 'This is an independent informational resource and is not operated by or affiliated with AllChinaBuy.',
  'footer.rights': 'All rights reserved.',
  'footer.externalNote': 'Links to the main website open in a new tab.',

  'categories.shoes': 'Shoes',
  'categories.hoodies': 'Hoodies / Sweaters',
  'categories.tshirts': 'T-Shirts',
  'categories.jackets': 'Jackets',
  'categories.pants': 'Pants / Shorts',
  'categories.headwear': 'Headwear',
  'categories.sets': 'Sets',
  'categories.underwear': 'Underwear / Underpants',
  'categories.jersey': 'Jersey',
  'categories.accessories': 'Accessories',
  'categories.bags': 'Bags',
  'categories.belts': 'Belts',
  'categories.perfumes': 'Perfumes',
  'categories.other': 'Other Stuff',
};